import { type ReactNode } from 'react';
import styles from './MapInspector.module.css';

export function MapInspector({
  title,
  type,
  status,
  facts,
  actions,
}: {
  title: string;
  type: string;
  status?: ReactNode;
  facts: Array<{ label: string; value: ReactNode }>;
  actions?: ReactNode;
}) {
  return (
    <aside className={styles.root}>
      <header>
        <span className={styles.eyebrow}>{type}</span>
        <h2>{title}</h2>
        {status}
      </header>
      <dl className={styles.facts}>
        {facts.map((fact) => (
          <div key={fact.label} className={styles.factRow}>
            <dt className={styles.label}>{fact.label}</dt>
            <dd className={styles.value}>{fact.value}</dd>
          </div>
        ))}
      </dl>
      {actions && <footer className={styles.footer}>{actions}</footer>}
    </aside>
  );
}
